export default {"id":"a7af1f8e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}